@if (showHeaderFooter) {
    <btl-header></btl-header>
}
<ng-container #modal></ng-container>
<router-outlet></router-outlet>
@if (showHeaderFooter) {
    <btl-footer></btl-footer>
}
